<template>
  <div class="hello">
    <modal height="auto" classes="msg-modal" width="300px" :adaptive="true" name="message">{{msg}}</modal>
    <modal
      height="auto"
      classes="msg-modal invite-modal"
      width="400px"
      :adaptive="true"
      name="invite"
    >
      <h4>{{$t('i18nView.inviteIntro')}}</h4>
      <p class="invite-tips">{{$t('i18nView.inviteTips')}}</p>
      <div v-if="!canInvite">
        <el-input class="invite-url" :readonly="true"></el-input>
      </div>
      <p v-else>
        <el-input class="invite-url" :readonly="true" v-model="referralUrl"></el-input>
        <el-button
          class="copy-btn"
          :data-clipboard-text="referralUrl"
          size="small"
          round
        >{{$t('i18nView.copy')}}</el-button>
      </p>

      <ol>
        <li>{{$t('i18nView.inviteTips1')}}</li>
        <li>{{$t('i18nView.inviteTips2')}}</li>
      </ol>
    </modal>
    <!-- <div>
      <span class="lang-switch">
        <a v-if="this.$i18n.locale === 'zh'" @click="changeLang('en')" href="javascript:;">En</a>
        <a v-else @click="changeLang('zh')" href="javascript:;">中</a>
      </span>
    </div>-->
    <div class="card">
      <div class="icon-zone">
        <i v-if="currentAccount" @click="getInviteUrl()" class="iconfont icon-invitation"></i>

        <i v-if="currentAccount" @click="goEdit()" class="iconfont icon-edit"></i>

        <i v-if="currentAccount" @click="logout()" class="iconfont icon-exit"></i>
      </div>
      <h2>{{$t('i18nView.personalInfo')}}</h2>
      <div v-if="currentAccount">
        <div class="baseinfo-wrap">
          <img class="avatar" :src="avatar" alt />
          <div class="baseinfo">
            <h3>EOS: {{currentAccount}}</h3>
            <h3 class="nick-name">{{$t('i18nView.nickname')}}: {{title}}</h3>
            <ul class="social-list">
              <li v-if="website">
                <el-tooltip class="item" effect="dark" :content="website" placement="top-start">
                  <a target="_blank" :href="website">
                    <i class="icon ico-website"></i>
                  </a>
                </el-tooltip>
              </li>
              <li v-if="telegram">
                <el-tooltip class="item" effect="dark" placement="top-start" :content="telegram">
                  <a target="_blank" :href="'https://t.me/' + telegram">
                    <i class="icon ico-telegram"></i>
                  </a>
                </el-tooltip>
              </li>
              <li v-if="twitter">
                <el-tooltip class="item" effect="dark" placement="top-start" :content="twitter">
                  <a target="_blank" :href="'https://twitter.com/' + twitter">
                    <i class="icon ico-twitter"></i>
                  </a>
                </el-tooltip>
              </li>
              <li v-if="wechat">
                <el-tooltip class="item" effect="dark" placement="top-start" :content="wechat">
                  <i class="icon ico-wechat"></i>
                </el-tooltip>
              </li>
            </ul>
          </div>
        </div>
        <hr />
        <div class="desc">{{desc}}</div>
        <div class="modifer">
          {{$t('i18nView.lastModifier')}}: {{modifier}}
          <!-- <span
            v-if="modifier === currentAccount && +verified !== 1"
            @click="apply"
          >提审</span>-->
        </div>
      </div>
      <div v-else>
        <el-button type="primary" @click="login()">{{$t('i18nView.login')}}</el-button>
      </div>
    </div>
    <div class="search-wrap">
      <input
        type="text"
        @keyup="searchKeyUp($event)"
        :placeholder="$t('i18nView.searchAccount')"
        v-model="searchAccount"
      />
      <i @click="search()" class="iconfont icon-search"></i>
    </div>
    <div class="lists">
      <el-tabs :stretch="true" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('i18nView.recently')" name="recently">
          <ul>
            <li class="account-item" v-for="item in recentList" @click="goInfo(item.account_name)">
              <img class="list-avatar" :src="item.avatar" alt />
              <div class="content">
                <p class="account-name">
                  {{item.account_name}}
                  <i class="iconfont icon-lock" v-if="item.status===3"></i>
                </p>
                <p class="title">{{item.title}}</p>

                <div class="price">
                  <p class="current-price">{{item.price}}</p>
                  <p class="price-tip">{{$t('i18nView.lastPrice')}}</p>
                </div>
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane :label="$t('i18nView.interested')" name="interest">
          <div v-if="!!searchList.length" class="search-result">
            <h4>
              {{$t('i18nView.searchList')}}
              <i @click="clearSearch()" class="iconfont icon-clear"></i>
            </h4>
            <ul>
              <li
                class="account-item"
                v-for="item in searchList"
                @click="goInfo(item.account_name)"
              >
                <img class="list-avatar" :src="item.avatar" alt />
                <div class="content">
                  <p class="account-name">
                    {{item.account_name}}
                    <i class="iconfont icon-lock" v-if="item.status===3"></i>
                  </p>
                  <p class="title">{{item.title}}</p>

                  <div class="price">
                    <p class="current-price">{{item.price}}</p>
                    <p class="price-tip">{{$t('i18nView.lastPrice')}}</p>
                  </div>
                </div>
              </li>
            </ul>
            <h4>{{$t('i18nView.intrestList')}}</h4>
          </div>
          <ul>
            <li
              class="account-item"
              v-for="item in interestList"
              @click="goInfo(item.account_name)"
            >
              <img class="list-avatar" :src="item.avatar" alt />
              <div class="content">
                <p class="account-name">
                  {{item.account_name}}
                  <i class="iconfont icon-lock" v-if="item.status===3"></i>
                </p>
                <p class="title">{{item.title}}</p>

                <div class="price">
                  <p class="current-price">{{item.price}}</p>
                  <p class="price-tip">{{$t('i18nView.lastPrice')}}</p>
                </div>
              </div>
            </li>
          </ul>
        </el-tab-pane>

        <el-tab-pane label="TOP 50" name="top">
          <ul>
            <li class="account-item" v-for="item in topList" @click="goInfo(item.account_name)">
              <img class="list-avatar" :src="item.avatar" alt />
              <div class="content">
                <p class="account-name">
                  {{item.account_name}}
                  <i class="iconfont icon-lock" v-if="item.status === 3"></i>
                </p>
                <p class="title">{{item.title}}</p>

                <div class="price">
                  <p class="current-price">{{item.price}}</p>
                  <p class="price-tip">{{$t('i18nView.lastPrice')}}</p>
                </div>
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane :label="$t('i18nView.mine')" name="mine">
          <ul>
            <li
              class="account-item"
              v-for="item in relativeList"
              @click="goInfo(item.account_name)"
            >
              <img class="list-avatar" :src="item.avatar" alt />
              <div class="content">
                <p class="account-name">
                  {{item.account_name}}
                  <i class="iconfont icon-lock" v-if="item.status===3"></i>
                </p>
                <p class="title">{{item.title}}</p>

                <div class="price">
                  <p class="current-price">{{item.price}}</p>
                  <p class="price-tip">{{$t('i18nView.lastPrice')}}</p>
                </div>
              </div>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import metadata from "./metadata";

export default metadata;
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.hello {
  max-width: 480px;

  .nick-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .invite-modal {
    font-size: 13px;
    border-radius: 10px;

    ol {
      padding-left: 12px;
      text-align: left;
    }
  }

  .icon-clear {
    float: right;
    font-weight: normal;
    font-size: 14px;
  }

  .el-tabs__nav-wrap:after {
    height: 1px;
  }

  h4 {
    font-size: 14px;
    margin: 10px 0;
  }

  h3 {
    font-size: 13px;
    margin: 4px 0;
  }

  .el-tabs__header {
    margin: 0;
  }

  hr {
    border: none;
    margin: 12px 0;
    border-bottom: 1px solid #eee;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 10px 0 6px;
  }

  .social-list {
    min-height: 16px;

    li {
      display: inline-block;

      .icon {
        display: inline-block;
        margin: 0 10px 0 0;
        width: 24px;
        height: 16px;
      }
    }
  }

  .search-wrap {
    position: relative;
    margin: 20px;

    input {
      width: 100%;
      border: none;
      border-radius: 100px;
      line-height: 1.5;
      font-size: 13px;
      padding: 8px 16px;
      box-sizing: border-box;
      background-color: #efefef;
      -webkit-appearance: none;
      outline: none;
    }

    .icon-search {
      position: absolute;
      padding: 6px;
      right: 5px;
      top: 2px;
      display: inline-block;
      font-size: 18px;
      color: #999;
    }
  }

  .desc {
    font-size: 12px;
    color: #333;
    margin-bottom: 10px;
  }

  .modifer {
    text-align: right;
    font-size: 12px;
    color: #999;
  }

  .el-tabs__active-bar {
    height: 1px;
  }

  .el-tabs__item {
    color: #999;
  }

  .el-tab-pane {
    font-size: 12px;
  }

  .card {
    position: relative;
    border-radius: 11px;
    background: #fff;
    box-shadow: 0px 2px 13px 0px rgb(228, 228, 228);
    margin: 0 15px 20px;
    padding: 4px 20px 12px;

    .icon-info {
      color: #4e9df7;
    }

    .icon-zone {
      position: absolute;
      color: #999;
      right: 20px;
      top: 14px;

      .iconfont {
        margin-left: 14px;
        display: inline-block;
        vertical-align: middle;
      }

      .icon-exit {
        display: none;
        color: #f56c6c;
      }
    }

    h2 {
      color: #d7d7d7;
      font-size: 13px;
      margin: 12px 0;
    }
  }
  .baseinfo-wrap {
    position: relative;
  }
  .avatar {
    position: absolute;
    display: inline-block;
    width: 70px;
    height: 70px;
    background: #f1f1f1;
    border-radius: 4px;
  }

  .baseinfo {
    margin-left: 90px;
    overflow: hidden;
  }

  .lists {
    padding: 0 20px;
    line-height: 1.5;

    .icon-lock {
      color: #666;
      font-size: 12px;
    }

    ul {
      li:last-child {
        .content {
          border-bottom: none;
        }
      }
    }
    .account-item {
      position: relative;
      padding: 8px 0;
    }

    p {
      margin: 0 0 4px;
    }
    .account-name,
    .current-price {
      font-weight: bold;
    }
    .title,
    .price-tip {
      color: #999;
    }

    .current-price,
    .price-tip {
      text-align: right;
    }

    .list-avatar {
      position: absolute;
      display: inline-block;
      vertical-align: middle;
      width: 40px;
      height: 40px;
      border-radius: 4px;
      background-color: #f1f1f1;
    }

    .content {
      display: block;
      border-bottom: 1px solid #e5e5e5;
      margin-left: 60px;
      min-height: 50px;
    }

    .price {
      position: absolute;
      top: 8px;
      right: 0;
      display: inline-block;
      vertical-align: middle;
    }
  }
}

.ico-website {
  background: url("../assets/website.png") no-repeat center;
}
.ico-telegram {
  background: url("../assets/telegram.png") no-repeat center;
}
.ico-facebook {
  background: url("../assets/facebook.png") no-repeat center;
}
.ico-twitter {
  background: url("../assets/twitter.png") no-repeat center;
}

.ico-wechat {
  background: url("../assets/wechat.png") no-repeat center;
}

@media screen and (min-width: 768px) {
  .icon-exit {
    display: inline-block !important;
  }
}
</style>
